'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {Link} from 'react-router';

var LoginForm = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user }, { loginError: state.auth.loginError };
}, authActions), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(LoginForm, _Component);

  function LoginForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LoginForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LoginForm.__proto__ || (0, _getPrototypeOf2.default)(LoginForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      username: '',
      password: ''
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _this.handleSubmit = function (event) {
      event.preventDefault();
      _this.props.login(_this.state.username, _this.state.password);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LoginForm, [{
    key: 'render',
    value: function render() {
      var loginError = this.props.loginError;

      var styles = require('./LoginForm.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Grid,
          null,
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              'div',
              { className: styles.loginForm },
              _react2.default.createElement(ReactBootstrap.Col, { md: 4, sm: 2, xs: 2, lg: 4 }),
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 4, sm: 8, xs: 8, lg: 4 },
                _react2.default.createElement(
                  ReactBootstrap.Panel,
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: styles.textCenter },
                    _react2.default.createElement(
                      'h1',
                      null,
                      'Login'
                    )
                  ),
                  _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                      ReactBootstrap.FormGroup,
                      null,
                      _react2.default.createElement(ReactBootstrap.FormControl, {
                        type: 'text',
                        placeholder: 'Enter username',
                        onChange: this.handleChange.bind(this, 'username') })
                    ),
                    _react2.default.createElement(
                      ReactBootstrap.FormGroup,
                      null,
                      _react2.default.createElement(ReactBootstrap.FormControl, {
                        type: 'password',
                        placeholder: 'Enter password',
                        onChange: this.handleChange.bind(this, 'password') })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.textCenter },
                      _react2.default.createElement(
                        ReactBootstrap.Button,
                        { className: 'btn btn-primary', type: 'submit', onClick: this.handleSubmit.bind(this) },
                        _react2.default.createElement('i', { className: 'fa fa-sign-in' }),
                        ' ',
                        'Log in'
                      )
                    ),
                    _react2.default.createElement('br', null),
                    loginError && _react2.default.createElement(
                      'p',
                      { style: { textAlign: "center" } },
                      'Your Username or Password is incorrect!'
                    )
                  )
                )
              ),
              _react2.default.createElement(ReactBootstrap.Col, { md: 4, sm: 2, xs: 2, lg: 4 })
            )
          )
        )
      );
    }
  }]);
  return LoginForm;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  loginError: _propTypes2.default.string,
  login: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = LoginForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForm/LoginForm.js
// module id = 1152
// module chunks = 0